import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import { Spacings } from '@styles/index';
import PropTypes from 'prop-types';
import CatalogueCard from './CatalogCard';

const SECTION_ID_BY_TYPE = {
  text_book: 'textbook-solutions',
  papers: 'previous-year-papers'
};

const StyH4 = styled(H4)`
  margin-top: ${Spacings.SPACING_7B};
  margin-bottom: ${Spacings.SPACING_4B};
  grid-column: span 18;
  color: var(--color-text-primary);
`;

const CatalogTypeBlock = ({ ctlgTypeData, goalData }) => {
  const {
    sectionTitle: ctlgTypeTitle,
    data: ctlgItems,
    type: ctlgType
  } = ctlgTypeData;
  return (
    <>
      {ctlgItems.length > 0 ? (
        <StyH4 id={SECTION_ID_BY_TYPE[ctlgType]}>{ctlgTypeTitle}</StyH4>
      ) : null}
      {ctlgItems.map((ctlgItem) => (
        <CatalogueCard
          ctlgItem={ctlgItem}
          key={ctlgItem.uid}
          goalData={goalData}
          ctlgType={ctlgType}
        />
      ))}
    </>
  );
};

export default CatalogTypeBlock;
CatalogTypeBlock.propTypes = {
  ctlgTypeData: PropTypes.objectOf(PropTypes.any),
  goalData: PropTypes.objectOf(PropTypes.any)
};
CatalogTypeBlock.defaultProps = {
  ctlgTypeData: {},
  goalData: {}
};
